module.exports = __webpack_public_path__ + "img/about1.8d076df3.png";